import React from 'react';
import { nlBr } from '@sizeid/commons/utils/strings';
import { WithTranslation } from 'next-i18next';

import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import Collapse from 'components/Collapse';
import { BENEFITS } from 'components/Navigation/constants';
import { withTranslation } from 'lib/i18n';

import features from './features';
import CollapseToggle from './CollapseToggle';

const BusinessBenefits: React.FC<WithTranslation> = props => (
  <>
    <H2 id={BENEFITS} css="margin-top: 80px;">
      {props.t('business.index.benefits.title')}
    </H2>
    <P bigOnDesktop>{nlBr(props.t('business.index.benefits.text'))}</P>
    {features(['more_orders', 'less_returns', 'size_charts'])}
    <Collapse toggleComponent={CollapseToggle}>
      <>
        {features(['marketing', 'users', 'api'])}
        {features(['trends', 'competitive_advantage', 'easy_implementation'])}
        {features(['low_costs', 'personalization', 'service_and_support'])}
      </>
    </Collapse>
  </>
);

export default withTranslation('pages')(BusinessBenefits);
